import * as Types from '../../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAiGeneratedSummaryQueryVariables = Types.Exact<{
  input: Types.GenerateAiResumeSummaryExampleInput;
}>;


export type GetAiGeneratedSummaryQuery = { __typename?: 'Query', generateAIResumeSummaryExample?: { __typename?: 'ResumeSummaryExamplePayload', extendedResults: Array<{ __typename?: 'ResumeSummaryExample', id: string, result: string }> } | null };


export const GetAiGeneratedSummaryDocument = gql`
    query GetAIGeneratedSummary($input: GenerateAIResumeSummaryExampleInput!) {
  generateAIResumeSummaryExample(input: $input) {
    extendedResults {
      id
      result
    }
  }
}
    `;

/**
 * __useGetAiGeneratedSummaryQuery__
 *
 * To run a query within a React component, call `useGetAiGeneratedSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiGeneratedSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiGeneratedSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAiGeneratedSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetAiGeneratedSummaryQuery, GetAiGeneratedSummaryQueryVariables> & ({ variables: GetAiGeneratedSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiGeneratedSummaryQuery, GetAiGeneratedSummaryQueryVariables>(GetAiGeneratedSummaryDocument, options);
      }
export function useGetAiGeneratedSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiGeneratedSummaryQuery, GetAiGeneratedSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiGeneratedSummaryQuery, GetAiGeneratedSummaryQueryVariables>(GetAiGeneratedSummaryDocument, options);
        }
export function useGetAiGeneratedSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAiGeneratedSummaryQuery, GetAiGeneratedSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAiGeneratedSummaryQuery, GetAiGeneratedSummaryQueryVariables>(GetAiGeneratedSummaryDocument, options);
        }
export type GetAiGeneratedSummaryQueryHookResult = ReturnType<typeof useGetAiGeneratedSummaryQuery>;
export type GetAiGeneratedSummaryLazyQueryHookResult = ReturnType<typeof useGetAiGeneratedSummaryLazyQuery>;
export type GetAiGeneratedSummarySuspenseQueryHookResult = ReturnType<typeof useGetAiGeneratedSummarySuspenseQuery>;
export type GetAiGeneratedSummaryQueryResult = Apollo.QueryResult<GetAiGeneratedSummaryQuery, GetAiGeneratedSummaryQueryVariables>;